import React, { useEffect, useState } from 'react';
import Checkbox from './Checkbox';
const HomeTypesFilter = ({ title, homeTypeValues, homeTypesData, onChange, className }) => {
    const [homeTypes, setHomeTypes] = useState(homeTypesData);
    useEffect(() => {
        const homeTypesCopy = homeTypes;
        homeTypesCopy.forEach((homeType) => {
            if (homeTypeValues.includes(homeType.value)) {
                homeType.checked = true;
            }
            else {
                homeType.checked = false;
            }
        });
        setHomeTypes(homeTypesCopy);
    }, [homeTypeValues]);
    function selectedTypesToArray() {
        return homeTypes.filter((type) => type.checked).map((type) => type.value);
    }
    function onSelect(homeTypeValue, checked) {
        // Update the checked value for the correct home type in the list
        const homeTypesCopy = homeTypes;
        const updatedTypeIndex = homeTypes.findIndex((home) => home.value === homeTypeValue);
        homeTypesCopy[updatedTypeIndex].checked = checked;
        setHomeTypes(homeTypesCopy);
        onChange(selectedTypesToArray());
    }
    return (React.createElement("div", { className: 'homeTypeFilters' + (className ? ' ' + className : '') },
        React.createElement("h3", { className: "filter-title" }, title),
        homeTypes.map((type, index) => (React.createElement(Checkbox, { key: index, value: type.value, id: type.id, label: type.label, checked: homeTypeValues.includes(type.value), onChange: (checked) => onSelect(type.value, checked) })))));
};
export default HomeTypesFilter;
